"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _path;
var Quote = function Quote(props) {
  return /*#__PURE__*/_react.default.createElement("svg", Object.assign({
    viewBox: "0 0 96 96"
  }, props), _path || (_path = /*#__PURE__*/_react.default.createElement("path", {
    d: "M31 15h35V7H31v8zM26 0h45a2 2 0 0 1 2 2v18a2 2 0 0 1-2 2H26a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zm-9 7.95v3a2 2 0 0 1-2 2h-3a2 2 0 0 0-2 2v72.04a2 2 0 0 0 2 2h72.62a2 2 0 0 0 2-2V14.95a2 2 0 0 0-2-2H82a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h9.619a2 2 0 0 1 2 2v86.04a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7.95a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2zM22 37h31a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H22a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2zm46 0h7a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-7a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2zm0 15h7a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-7a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2zm0 15h7a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-7a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2zM22 52h31a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H22a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2zm0 15h31a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H22a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2z",
    fill: "currentColor"
  })));
};
var _default = exports.default = Quote;